export default "__VITE_ASSET__ca183452__"